import {
  returnsPolicy,
  defectivePolicy,
  refundPolicy,
} from "../policies/terms";
import React from "react";
import PolicyPage from "../policies/PolicyPage";
const sections = [
  {
    id: "section-1",
    title: "About these terms",
    paragraphs: [
      "This website is operated by Technogenious Solutions Ltd., Shop 4B, 17 Molynes Road, Kingston, Jamaica. These terms apply to your use of the store and should be read with the Warranties, Privacy policy and Disclaimer pages.",
      "The website is intended for adults aged 18 and over. Use it lawfully, provide accurate information, and keep your account credentials confidential. Do not interfere with the website, attempt unauthorised access, or use it for fraudulent transactions.",
    ],
  },
  {
    id: "section-2",
    title: "Products and availability",
    paragraphs: [
      "Check product descriptions, model numbers and compatibility before ordering. Some products require a quotation because the price, configuration or availability needs confirmation. Images may illustrate a particular model or setup.",
      "Product prices and availability are checked again during checkout. Review any revised total before payment. If you identify an error, contact us before proceeding.",
    ],
  },
  {
    id: "section-3",
    title: "Prices in USD and JMD",
    paragraphs: [
      "Product prices are recorded in United States dollars (USD). Selecting Jamaican dollars (JMD) while browsing displays an approximate conversion. Card payments are charged in USD. If you select a JMD bank account at checkout, the market exchange rate and exact JMD amount due are locked when the order is placed and shown in the transfer instructions.",
      "Your bank or payment provider may apply conversion or transfer fees. Transfer the exact amount shown in the currency of your selected receiving account. Fees are separate from the order amount.",
    ],
  },
  {
    id: "section-4",
    title: "Checkout and payment",
    paragraphs: [
      "Review your items, contact details, delivery selection and final amount before paying. Card payments are processed through Stripe. Bank-transfer orders remain unpaid until an administrator confirms the funds have arrived. Uploading a receipt does not confirm payment. Keep your order reference for enquiries.",
      "If payment is processing, use the existing checkout to check its status rather than creating another payment. Contact us if you are unsure whether a payment has been completed.",
    ],
  },
  {
    id: "section-5",
    title: "Pickup and delivery",
    paragraphs: [
      "Store pickup is free. Bearer delivery to nearby addresses is $50.00 USD; confirm that your address is eligible. For local courier delivery, such as Knutsford Delivery or Door Way Express, the courier collects your order from our store and delivers it to you; you pay the courier’s rate on delivery, separately from your order. Checkout shows no courier fee because you pay the courier directly; courier delivery is not free.",
      "International delivery is estimated at $150.00 USD and is subject to change. We will ask you to agree to any additional amount first. Confirm destination availability and arrangements before ordering.",
      "Items are dispatched within two business days after your payment is confirmed. Carrier transit time is separate. We do not ship to P.O. boxes. Contact our team for express-delivery charges.",
    ],
  },
  {
    id: "section-6",
    title: "Machine configurations, leases and services",
    paragraphs: [
      "A machine configuration is a request for a quotation, not a completed order. The game remains fixed while hardware preferences are discussed. Our team confirms compatibility, specification, price, quantities, installation and delivery before an agreement is finalised.",
      "Leasing, service work and custom builds require their applicable written quotation or agreement. Operators are responsible for the permissions required for their premises and activities. Website information does not guarantee a business return.",
    ],
  },
  {
    id: "section-7",
    title: "Cancellations, returns and refunds",
    paragraphs: [
      "Contact us promptly to request cancellation. You may cancel an order for physical items before they have shipped or entered the shipping process.",
      returnsPolicy,
      defectivePolicy,
      refundPolicy,
    ],
  },
  {
    id: "section-8",
    title: "Warranties and customer rights",
    paragraphs: [
      "See the Warranties page for new-machine, used-machine and repair coverage and claim instructions. Nothing in these terms excludes statutory rights or remedies that cannot lawfully be excluded.",
    ],
  },
  {
    id: "section-9",
    title: "Privacy and third-party services",
    paragraphs: [
      "The privacy policy describes the handling of account, order and enquiry information and browser storage. Payment, messaging and linked manufacturer services have their own terms and privacy notices.",
    ],
  },
  {
    id: "section-10",
    title: "Website content and use",
    paragraphs: [
      "Website text, branding and images are protected by applicable intellectual-property rights. Do not copy or commercially reuse content without permission or another lawful basis. Manufacturer names and trademarks remain the property of their owners.",
      "Website information can change and services may be interrupted. The Disclaimer explains the limits of general product guidance and estimates; it does not cancel an agreed warranty or a right that cannot lawfully be excluded.",
    ],
  },
  {
    id: "section-11",
    title: "Governing law and disputes",
    paragraphs: [
      "These terms are governed by Jamaican law, subject to mandatory protections that apply. Contact us first with your order reference and a description of the concern so we can try to resolve it. This does not prevent you from using available consumer complaint procedures or the courts with jurisdiction. Consumer complaints may also be raised with Jamaica’s Consumer Affairs Commission.",
    ],
  },
  {
    id: "section-12",
    title: "Changes and contact",
    paragraphs: [
      "Updated website terms will be posted here with a revised date. Changes do not retrospectively remove rights relating to an existing purchase. For order, warranty or policy questions, contact technogeniousja@gmail.com or +1 (876) 648-4163.",
    ],
  },
];
export default function Policy() {
  return (
    <PolicyPage
      title="Terms & conditions"
      intro="Terms for using the store, purchasing products and requesting machine or technical-service quotations."
      sections={sections}
    />
  );
}
